import React from 'react';
import './Cart.css'

const Cart = (props) => {
    const {cart} = props;
    let total =0;
    for(const carts of cart){
        total = total + carts.price
    }
    
    return (
        <div>
            <div className="d-flex justify-content-evenly">
                        <h5>Total Tricket</h5>
                        <h3>{props.cart.length}</h3>
                    </div>

                    <table class="table">

                        <tbody>
                            <tr className="price">
                                <th scope="row" >Total Price :</th>
                                <th>{total}</th>
                            </tr>
                            {
                                cart.map(newcart=><tr>
                                    <td>

                                    <img src={newcart.img} alt="" className="img-fluid cart_img"/>
                                    </td>
                                    <td>{newcart.name.slice(0,15)}</td>
                                    </tr>)
                            }
                           


                        </tbody>
                    </table>
        </div>
    );
};

export default Cart;